import React, { useState, useEffect } from "react";
import { Card, PageHeader } from "../../../components/common";
import { useAppDispatch, useAppSelector, getStudentsThunk } from "../../../redux";
import chevronIcon from "../../../assets/icons/chevron-down.svg";
import "./TeacherStudents.css";

const TeacherStudents: React.FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { records } = useAppSelector((state) => state.student);
  const [expandedId, setExpandedId] = useState<string | null>(null);

  useEffect(() => {
    if (user?.id) {
      dispatch(getStudentsThunk(user.id));
    }
  }, [dispatch, user?.id]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Card style={{ padding: "24px" }}>
        <PageHeader
          title="My Students"
          subtitle="View and manage your allocated students."
        />

        <div className="student-list" style={{ marginTop: "20px" }}>
          {records.map((student) => {
            const isExpanded = expandedId === student.id;
            const fullName = [student.First_Name, student.Middle_Name, student.Last_Name].filter(Boolean).join(" ");
            const displayName = student.Student_Number2 ? `${student.Student_Number2} - ${fullName}` : fullName;

            return (
              <div key={student.id} className="student-item">
                <div
                  className="student-header"
                  onClick={() => setExpandedId(isExpanded ? null : student.id)}
                >
                  <div className="student-main-info">
                    <span className="student-name">
                      {displayName}
                    </span>
                    <span className="student-email">{student.Email}</span>
                  </div>
                  <img
                    src={chevronIcon}
                    alt="Toggle"
                    className={`expand-icon ${isExpanded ? "expanded" : ""}`}
                  />
                </div>

                {isExpanded && (
                  <div className="student-details">
                    <div className="detail-section">
                      <h4 className="detail-section-title">Student Details</h4>
                      <div className="detail-grid">
                        <div className="detail-item">
                          <span className="detail-label">Phone</span>
                          <span className="detail-value">{student.Phone}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Gender</span>
                          <span className="detail-value">{student.Gender}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Centre</span>
                          <span className="detail-value">{student.Centre}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Mandal</span>
                          <span className="detail-value">{student.Mandal}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Month of Birth</span>
                          <span className="detail-value">{student.Month_of_Birth}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Year of Birth</span>
                          <span className="detail-value">{student.Year_of_Birth}</span>
                        </div>
                      </div>
                    </div>

                    <div className="detail-section">
                      <h4 className="detail-section-title">Parent Details</h4>
                      <div className="detail-grid">
                        <div className="detail-item">
                          <span className="detail-label">Parent First Name</span>
                          <span className="detail-value">{student.Parent_First_Name}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Parent Last Name</span>
                          <span className="detail-value">{student.Parent_Last_Name}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Parent Email</span>
                          <span className="detail-value">{student.Parent_Email}</span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Parent Mobile</span>
                          <span className="detail-value">{student.Parent_Mobile}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
};

export default TeacherStudents;
